<template>
  <div id="app" :class="isMobileBrowser ? 'mobile_wrap' : ''">
    <router-view/>
  </div>
</template>

<script>
import './css/common.css'
import './css/font.css'
import './css/color.css'
import './css/input.css'
import './css/paginate.css'
import './css/popup.css'
import common from './script/common'

export default {
  name: 'App',
  data () {
    return {
      isMobileBrowser: common.detectMobileBrowser()
    }
  }
}
</script>

<style>
html, body {
  margin: 0;
  padding: 0;
}

#app {
  font-family: 'Noto Sans KR', sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/App.vue